import { StoreVariant, StoreVariantColor } from '../models';

export const AGE_VARIATION_TYPE = 0;
export const SIZE_VARIATION_TYPE = 1;
export const KIT_QUANTITY_VARIATION_TYPE = 2;
export const SHOE_SIZE_VARIATION_TYPE = 3;

const SIZE_LIKE_VARIATION_TYPES = new Set([AGE_VARIATION_TYPE, SIZE_VARIATION_TYPE, SHOE_SIZE_VARIATION_TYPE]);

export function getVariationLabel(variationTypeId: number | undefined): string {
  if (variationTypeId === undefined) return 'Variação';
  if (SIZE_LIKE_VARIATION_TYPES.has(variationTypeId)) return 'Tamanho';
  if (variationTypeId === KIT_QUANTITY_VARIATION_TYPE) return 'Quantidade de peças';
  return 'Variação';
}

export function extractUniqueColors(variants: StoreVariant[]): StoreVariantColor[] {
  const colors: StoreVariantColor[] = [];
  const seen = new Set<number>();
  for (const v of variants) {
    if (v.color && !seen.has(v.color.id)) {
      seen.add(v.color.id);
      colors.push(v.color);
    }
  }
  return colors;
}

export function extractAvailableValues(
  variants: StoreVariant[],
  selectedColor: StoreVariantColor | null
): string[] {
  const values: string[] = [];
  const seen = new Set<string>();
  for (const v of variants) {
    if (selectedColor && v.color?.id !== selectedColor.id) continue;
    if (!seen.has(v.variationValue)) {
      seen.add(v.variationValue);
      values.push(v.variationValue);
    }
  }
  return values;
}

export function resolveVariant(
  variants: StoreVariant[],
  hasColors: boolean,
  selectedColor: StoreVariantColor | null,
  selectedValue: string | null
): StoreVariant | null {
  if (variants.length === 0) return null;
  if (hasColors && selectedColor && selectedValue) {
    return (
      variants.find(
        (v) => v.variationValue === selectedValue && v.color?.id === selectedColor.id
      ) ?? null
    );
  }
  if (!hasColors && selectedValue) {
    return variants.find((v) => v.variationValue === selectedValue) ?? null;
  }
  return null;
}
